import React, {Component} from "react";
import {getConfigDaily, monthOptions, yearOptions} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import * as R from 'ramda'
import moment from "moment";
class DailySalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount() {
    const currentMonth = Number(moment().format("MM"));
    const currentYear = Number(moment().format("YYYY"));

    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find((item) => item.value === currentMonth),
      year: yearOptions.find(
        (item) => item.value === currentYear
      ),
      tableConfig: getConfigDaily(null, null, "sales"),
    }));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(!R.equals(JSON.stringify(prevProps.search),JSON.stringify(this.props.search))){
      this.handleSearch();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    const { month, year } = this.state
    this.setState({
      tableConfig: getConfigDaily(month?.value, year?.value, "sales"),
    })
    this.fetchData();
  };

  transformResponse = (data) =>{
        const transformed =  data.map(item=>{
            const {dataSalesDaily={},...rest} = item;
            return {
                ...rest,
                ...dataSalesDaily,
            }
        })
        return transformed
    }

  fetchData = async () => {
    try {
      this.props.triggerLoading()
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarianPerCabang,
        setError: this.props.setError,
        menuName: "Dashboard Salesman - Laporan Harian",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          year: this.state.year?.value,
          month: this.state.month?.value,
          employeeIdSales: this.props.search?.selectedSales,
          team: true,
          employeeIdTeamLeader: this.props.idLeader
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: this.transformResponse(res.data.data),
        }));
      }
      this.props.triggerLoading()
    } catch (error) {
      this.props.triggerLoading();
      console.log(error);
    }
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            isClearable
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            isClearable
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </>
    );
  }
}

export default DailySalesReport;